import React, { useState, useRef } from "react";
import RcListView from "./RcListView";
import RcPoView from "./RcPoView";
import RcCreatePage from "./RcCreatePage";
import RcExtractPage from "./RcExtractPage";

const RateContract = () => {
    const [selectedContract, setSelectedContract] = useState(null);
    const [createRc, setCreateRc] = useState(false);
    const [extractRc, setExtractRc] = useState(false);
    const [viewPo, setViewPo] = useState(false);
    const [loading, setLoading] = useState(false);
    const rcInputRef = useRef(null);
    const [savedRc, setSavedRc] = useState(null);
    const [activeTab, setActiveTab] = useState(0);
    const [extractedRecords, setExtractedRecords] = useState([]);

    const handleAddRc = () => setCreateRc(true);
    const handleOpenExtractPage = () => setExtractRc(true);
    const handleBackToHome = () => {
        setCreateRc(false);
        setExtractRc(false);
        setViewPo(false);
        setSelectedContract(null);
    };

    const handleViewPo = (contract) => {
        setSelectedContract(contract);
        setViewPo(true);
    };

    const handleSaveRc = (newSavedRc) => {
        setSavedRc(newSavedRc);
        setCreateRc(false);
    };

    const handleSaveExtracted = (record) => {
        setExtractedRecords((prev) => [record, ...prev]);
        setActiveTab(1);
        setExtractRc(false);
    };

    return (
        <>
            { !createRc && !viewPo && !extractRc && (
                <RcListView
                    onAddRc={ handleAddRc }
                    onExtractData={ handleOpenExtractPage }
                    onViewPo={ handleViewPo }
                    savedRc={ savedRc }
                    activeTab={ activeTab }
                    onActiveTabChange={ setActiveTab }
                    extractedRecords={ extractedRecords }
                />
            ) }

            { viewPo && selectedContract && (
                <RcPoView
                    selectedContract={ selectedContract }
                    onBack={ handleBackToHome }
                    rcInputRef={ rcInputRef }
                    loading={ loading }
                    setLoading={ setLoading }
                />
            ) }

            { createRc && (
                <RcCreatePage
                    onBack={ handleBackToHome }
                    rcInputRef={ rcInputRef }
                    loading={ loading }
                    setLoading={ setLoading }
                    onSave={ handleSaveRc }
                />
            ) }

            { extractRc && (
                <RcExtractPage
                    onBack={ handleBackToHome }
                    onSave={ handleSaveExtracted }
                />
            ) }
        </>
    );
};

export default RateContract;
